import React from 'react';
import { useNavigate, useLocation, useSearchParams } from 'react-router-dom';

const OrderConfirmationPage = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [searchParams] = useSearchParams();
  const params = location.state || {};
  const { orderId, total } = params;

  const success = searchParams.get('success') === '1' || !!orderId;

  return (
    <div className="confirmation-page">
      <div className="confirmation-card">
        {success ? (
          <>
            <div className="confirmation-icon success">✅</div>
            <h2 className="confirmation-title">Order Placed!</h2>
            <p className="confirmation-subtitle">
              Your order has been confirmed. The kitchen will prepare your meal for pickup.
            </p>
            {orderId && <p className="confirmation-order-id">Order #{orderId}</p>}
            {total && <p className="confirmation-total">Total: ${Number(total).toFixed(2)}</p>}
            <div className="confirmation-actions">
              <button className="btn-primary" onClick={() => navigate('/customer/orders')}>
                Track Order
              </button>
              <button className="btn-outline" onClick={() => navigate('/customer')}>
                Continue Shopping
              </button>
            </div>
          </>
        ) : (
          <>
            <div className="confirmation-icon error">❌</div>
            <h2 className="confirmation-title">Order Failed</h2>
            <p className="confirmation-subtitle">
              Something went wrong. Please try again.
            </p>
            <button className="btn-primary" onClick={() => navigate('/customer/cart')}>
              Go Back to Cart
            </button>
          </>
        )}
      </div>
    </div>
  );
};

export default OrderConfirmationPage;
